import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'

Vue.use(Router)
const router = new Router({
    // linkActiveClass:'active',
    // linkExactActiveClass:'exact-active',
    routes,
    mode: 'history',
    base: '/v2/'
})

router.beforeEach((to, from, next) => {
    next()
})

router.afterEach(() => {
    window.scrollTo(0, 0)
})

export default router